import { render, staticRenderFns } from "./SystemCurve.vue?vue&type=template&id=3d8ab212&scoped=true&"
import script from "./SystemCurve.vue?vue&type=script&lang=js&"
export * from "./SystemCurve.vue?vue&type=script&lang=js&"
import style0 from "./SystemCurve.vue?vue&type=style&index=0&id=3d8ab212&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8ab212",
  null
  
)

export default component.exports